export default "__VITE_ASSET__BFNcUS7I__"